import { render, staticRenderFns } from "./model_postal.vue?vue&type=template&id=07aed048"
import script from "./model_postal.vue?vue&type=script&lang=js"
export * from "./model_postal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports